(function() {
	$('.information__tips').each(function (index, item) {
        $(item).find(".js-toggle-search-tips").on('mouseenter', function () {
            $(item).toggleClass('open');
        }).on('mouseleave', function () {
            $(item).removeClass("open");
        })
	});
})();